import './index.css'

import React, { Component } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import StatsCard from './stats-card'
import ResumeTable from './resume-table'

class AdminDashboard extends Component {
  constructor(props) {
    super(props)

    const adminData = JSON.parse(localStorage.getItem('adminData') || '{}')

    this.state = {
      token: adminData.token || null,
      stats: null,
      resumes: [],
      total: 0,
      page: 1,
      limit: 20,
      loadingStats: true,
      loadingResumes: true,
      deleting: null,
    }
  }

  authHeader = () => ({
    headers: { Authorization: this.state.token },
  })

  componentDidMount() {
    this.fetchStats()
    this.fetchResumes(1)
  }

  fetchStats = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/admin/stats`, this.authHeader())
      .then(res => this.setState({ stats: res.data, loadingStats: false }))
      .catch(() => this.setState({ loadingStats: false }))
  }

  fetchResumes = page => {
    this.setState({ loadingResumes: true })
    axios
      .get(`${process.env.REACT_APP_API_URL}/admin/resumes?page=${page}`, this.authHeader())
      .then(res => {
        this.setState({
          resumes: res.data.items,
          total: res.data.total,
          page: res.data.page,
          limit: res.data.limit,
          loadingResumes: false,
        })
      })
      .catch(() => this.setState({ loadingResumes: false }))
  }

  handlePageChange = page => {
    this.fetchResumes(page)
  }

  handleDelete = hash => {
    this.setState({ deleting: hash })
    axios
      .delete(`${process.env.REACT_APP_API_URL}/admin/resumes/${hash}`, this.authHeader())
      .then(() => {
        this.setState(prev => ({
          resumes: prev.resumes.map(r =>
            r.hashName === hash ? { ...r, status: false } : r
          ),
          deleting: null,
          stats: prev.stats
            ? { ...prev.stats, totalResumes: prev.stats.totalResumes - 1 }
            : null,
        }))
      })
      .catch(() => this.setState({ deleting: null }))
  }

  logout = () => {
    localStorage.removeItem('adminData')
    this.props.history.push('/admin/login')
  }

  render() {
    const { stats, resumes, total, page, limit, loadingStats, loadingResumes, deleting } =
      this.state

    return (
      <div className="admin-layout">
        <header className="admin-header">
          <Link to="/" className="admin-logo-link">
            <img src="/logo.png" alt="makeresume.co" className="logo-home" />
          </Link>
          <span className="admin-title">Admin Dashboard</span>
          <button className="admin-btn-logout" onClick={this.logout}>
            Logout
          </button>
        </header>

        <main className="admin-main">
          <section className="admin-stats-section">
            {loadingStats ? (
              <div className="admin-loading">Loading stats…</div>
            ) : (
              <div className="admin-stats-grid">
                <StatsCard label="Total Resumes" value={stats?.totalResumes} icon="📄" />
                <StatsCard label="Total Users" value={stats?.totalUsers} icon="👤" />
                <StatsCard
                  label="Total Views"
                  value={stats?.totalViews}
                  icon="👁"
                  subValue={stats?.lastMonthViews}
                  subLabel="last 30 days"
                />
                <StatsCard
                  label="Total Downloads"
                  value={stats?.totalDownloads}
                  icon="⬇"
                  subValue={stats?.lastMonthDownloads}
                  subLabel="last 30 days"
                />
              </div>
            )}
          </section>

          <section className="admin-resumes-section">
            <h2 className="admin-section-title">Resumes</h2>
            {loadingResumes ? (
              <div className="admin-loading">Loading resumes…</div>
            ) : (
              <ResumeTable
                items={resumes}
                total={total}
                page={page}
                limit={limit}
                deleting={deleting}
                onDelete={this.handleDelete}
                onPageChange={this.handlePageChange}
              />
            )}
          </section>
        </main>
      </div>
    )
  }
}

export default AdminDashboard
